module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zhFukuan"
  }, [_c('meta', {
    attrs: {
      "name": "description",
      "content": "以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"
    }
  }), _vm._v(" "), _c('title', [_vm._v("订单支付-以诺教育")]), _vm._v(" "), _c('headTop'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "PaymentOrder"
    }
  }, [_c('div', {
    staticClass: "imagess"
  }), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "Order"
    }, [_c('div', {
      staticClass: "zhorderNumber"
    }, [_c('div', {
      staticClass: "numCon"
    }, [_c('p', {
      staticClass: "number"
    }, [_vm._v("订单已生成！订单号：" + _vm._s(item.order_id))]), _vm._v(" "), _c('p', {
      staticClass: "zhcontents"
    }, [_vm._v("\n              课程名称：" + _vm._s(item.name) + "\n              "), _c('br'), _vm._v("\n              下单时间：" + _vm._s(item.order_date) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "paymenta"
    }, [_c('p', {
      staticClass: "pay"
    }, [_vm._v("待支付")]), _vm._v(" "), _c('p', {
      staticClass: "payNowt"
    }, [_vm._v("￥" + _vm._s(item.unit_price))])])]), _vm._v(" "), _c('div', {
      staticClass: "close",
      attrs: {
        "id": "closeT"
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "erweima"
  }, [_c('div', {
    staticClass: "QRtext"
  }, [_vm._v("请使用微信“扫一扫”，扫描二维码支付")]), _vm._v(" "), _c('div', {
    staticClass: "qqq",
    domProps: {
      "innerHTML": _vm._s(_vm.a)
    }
  }, [_vm._v(_vm._s(_vm.a))])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d71bcda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/paymentQR.vue
// module id = 548
// module chunks = 1